import { Component, Input } from '@angular/core';
import { UserFavoriteCardData } from '../../../user-favorite-data.model';

@Component({
  selector: 'favorite-card-drivers',
  template: `
    <ul *ngIf="data.drivers.length > 0" class="list">
      <li *ngFor="let driver of data.drivers" class="eva-3-tooltip -top  -white -{{tooltipsPosition || 'right'}}">
        <span class="eva-3-driver" ngClass="{{driver.eva_class}}">
          <span class="driver-text">
            <i *ngIf="driver.icon" class="-eva-3-mr-xsm eva-3-icon-{{ driver.icon }} -eva-3-icon-xsm"></i
            >{{ driver.text }}
          </span>
        </span>
        <div *ngIf="driver.tooltip" class="tooltip-container -eva-3-shadow-static">
          <i class="tooltip-marker"></i>
          <div class="tooltip-content">
            <p class="tooltip-text">{{ driver.tooltip.text }}</p>
          </div>
        </div>
      </li>
    </ul>
  `,
  styleUrls: ['./favorite-card-drivers.component.scss'],
})
export class FavoriteCardDriversComponent {
  @Input() data: UserFavoriteCardData;
  @Input() tooltipsPosition: string;
}
